export default Object.freeze({
  User: 1,
  Channel: 2,
  GroupChat: 3,
});
